/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface Playlist
 */
export interface Playlist {
  /**
   * The playlist's unique identifier.
   * @type number
   * @memberof Playlist
   */
  playlistKey: number
  /**
   * Display name of the playlist.
   * @type string
   * @memberof Playlist
   */
  name: string
  /**
   * Defines the category of the playlist.'LearningCenter' or 'BusinessCenter' content.
   * @type string
   * @memberof Playlist
   */
  playlistType: PlaylistPlaylistTypeEnum
  /**
   * The actor key associated with this playlist, if any.
   * @type number
   * @memberof Playlist
   */
  actorKey?: number | null
  /**
   * The user key associated with this playlist.
   * @type number
   * @memberof Playlist
   */
  userKey?: number
  /**
   * The date on which the playlist was created.
   * @type Date
   * @memberof Playlist
   */
  createdDate?: Date
}

/**
 * @export
 * @enum {string}
 */
export enum PlaylistPlaylistTypeEnum {
  LearningCenter = 'LearningCenter',
  BusinessCenter = 'BusinessCenter',
}

export function PlaylistFromJSON(json: any): Playlist {
  return PlaylistFromJSONTyped(json, false)
}

export function PlaylistFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Playlist {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlistKey: json['playlistKey'],
    name: json['name'],
    playlistType: json['playlistType'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
    createdDate: !exists(json, 'createdDate')
      ? undefined
      : new Date(json['createdDate']),
  }
}

export function PlaylistToJSON(value?: Playlist | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlistKey: value.playlistKey,
    name: value.name,
    playlistType: value.playlistType,
    actorKey: value.actorKey,
    userKey: value.userKey,
    createdDate:
      value.createdDate === undefined
        ? undefined
        : value.createdDate.toISOString(),
  }
}
